<div
  class="fixed z-[9999] pointer-events-none top-3 left-3 right-3 sm:top-6 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 w-auto sm:w-full sm:max-w-md space-y-3">
  @if (toasts$ | async; as toasts) {
    @for (t of toasts; track trackById($index, t)) {
      <div class="pointer-events-auto">
        <fuse-alert
          [name]="t.id"
          [appearance]="'soft'"
          [type]="t.type"
          [dismissible]="t.dismissible"
          [dismissed]="false"
          class="rounded-xl sm:rounded-2xl"
          (afterDismissed)="dismiss(t.id)"
        >
          <span>{{ t.message }}</span>
          @if (t.action) {
            <button type="button"
                    class="ml-2 font-semibold underline cursor-pointer bg-transparent border-0 p-0 text-inherit"
                    (click)="onAction(t)">
              {{ t.action.label }}
            </button>
          }
        </fuse-alert>
      </div>
    }
  }
</div>
